import {
  incidentNotifiersViewColumns,
  incidentNotifiersSearchSchema,
  mapIncidentNotifiersViewQuery,
} from "./IncidentNotifiersView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { PaginationInput } from "../repository/data.default";
import { getCompanyIncidentNotifiers } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface IncidentNotifiersViewProps {
  readonly companyUid: string;
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function IncidentNotifiersView(props: IncidentNotifiersViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  // Always scope to this company's notify roster by injecting a companyUid condition ahead of any
  // search-form conditions — so initial load + searches stay company-scoped.
  const scopedRequest = createGridRequest(
    (input: PaginationInput) =>
      getCompanyIncidentNotifiers({
        ...input,
        searchQuery: {
          conditions: [
            {
              field: "companyUid",
              operation: QueryOperation.Equal,
              values: [props.companyUid],
            },
            ...(input.searchQuery?.conditions ?? []),
          ],
        },
      }),
    { retry: true },
  );

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={incidentNotifiersViewColumns}
      schema={incidentNotifiersSearchSchema}
      mapQuery={mapIncidentNotifiersViewQuery}
      onSearch={props.onSearch}
      request={scopedRequest}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("CompanyIncidentTypeNotifiers", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CompanyIncidentTypeNotifiers", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default IncidentNotifiersView;
